export const categoryLevel1 = 'pub_categoryLevel1';
export const recentSearches = 'recentSearches';
